import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <path d="M5.93333 19L5 18.0755L11.1333 12L5 5.92453L5.93333 5L13 12L5.93333 19Z" fill="#3C101E" />
      <path d="M11.9333 19L11 18.0755L17.1333 12L11 5.92453L11.9333 5L19 12L11.9333 19Z" fill="#3C101E" />
    </Icons>
  );
}
